import React, { useEffect, useState, useRef } from "react";
import Typed from 'react-typed';
import { useNavigate } from 'react-router-dom';
import "./home.css";
import Navbar from "./Navbar";
import BounceLoader from "react-spinners/BounceLoader";
import { gsap } from "gsap";

const Home = () => {
    const [divStyle, setDivStyle] = useState();
    const [imgStyle, setImgStyle] = useState();
    const [bgStyle, setBgStyle] = useState();
    const [borderStyle, setBorderStyle] = useState();
    const [imgSideBorderStyle, setImgSideBorderStyle] = useState();
    const [detailsStyle, setDetailsStyle] = useState();
    const [bottomHeightStyle, setBottomHeightStyle] = useState();
    const [startBtnStyle, setstartBtnStyle] = useState();
    const [socialIconStyle, setsocialIconStyle] = useState();
    const [startbtnIcon, setstartbtnIcon] = useState();
    const [aboutStyle, setaboutStyle] = useState();
    const [workStyle, setworkStyle] = useState();
    const [startbtnText, setstartbtnText] = useState();
    const [isStarted, setisStarted] = useState(false);

    const hiRef = useRef();
    const el = useRef();
    const q = gsap.utils.selector(el);

    const mainRef = useRef();
    const navigating = useNavigate()

    useEffect(() => {
       document.title = "Home"
    }, [])

    var mobileScreen = window.matchMedia("(max-width: 800px)");

    const startWebsite = () => {

        if (mobileScreen.matches) {
            if (isStarted == false) {
                const bgStyle = {
                    height: "100%",
                }
                setBgStyle(bgStyle)

                const divStyle = {
                    height: "70vh",
                    transition: "all 0.8s ease-in-out 0.9s"
                }
                setDivStyle(divStyle)

                const borderStyle = {
                    border: "2px solid rgb(252, 246, 244)",
                    borderBottom: "none",
                    transition: "all 0.1s linear 0.88s"

                }
                setBorderStyle(borderStyle)

                const imgSideBorderStyle = {
                    border: "2px solid rgb(0, 0, 0)",
                    borderTop: "none",
                    transition: "all 0.1s linear 0.88s"

                }
                setImgSideBorderStyle(imgSideBorderStyle)

                const detailsStyle = {
                    opacity: 1,
                    visibility: "visible",
                    transition: "all 0.1s ease 0.8s"
                }
                setDetailsStyle(detailsStyle)

                const imgStyle = {
                    opacity: 1,
                    visibility: "visible",
                    transition: "all 1s ease-in-out 1.9s"
                }
                setImgStyle(imgStyle)

                const bottomHeightStyle = {
                    height: "0%",
                    transition: "all 0.1s ease-in-out 1.4s"
                }
                setBottomHeightStyle(bottomHeightStyle)

                const startBtnStyle = {
                    top: "93%",
                    left: "90%",
                    // transform: "translate(-50%, -50%)"
                }
                setstartBtnStyle(startBtnStyle)

                const socialIconStyle = {
                    color: "0E0E0E",
                    background: "0E0E0E",
                    transition: "all 0.1s ease 1.2s"
                }
                setsocialIconStyle(socialIconStyle)

                const startbtnIcon = {
                    fontSize: "50px",
                    transition: "all 1s ease 0s"
                }
                setstartbtnIcon(startbtnIcon)

                const startbtnText = { opacity: 0, visibility: "hidden", fontSize: "0em", transition: "all 1s ease 0s" }
                setstartbtnText(startbtnText)


                const aboutStyle = { color: "#0e0e0e" }
                setaboutStyle(aboutStyle)

                const workStyle = { color: "rgb(252, 246, 244)", transition: "all 0.3s ease-in-out 0.5s" }
                setworkStyle(workStyle)

                setisStarted(true)
            }
            if (isStarted == true) {
                const bgStyle = {
                    height: 0,
                    width: "50%"
                }
                setBgStyle(bgStyle)

                const divStyle = {
                    height: 0
                }
                setDivStyle(divStyle)

                const borderStyle = {
                    border: "none"
                }
                setBorderStyle(borderStyle)

                const imgSideBorderStyle = {
                    border: "none"

                }
                setImgSideBorderStyle(imgSideBorderStyle)

                const detailsStyle = {
                    opacity: 0,
                    visibility: "hidden",
                }
                setDetailsStyle(detailsStyle)

                const imgStyle = {
                    opacity: 0,
                    visibility: "hidden",
                }
                setImgStyle(imgStyle)

                const bottomHeightStyle = {
                    height: "0%",
                }
                setBottomHeightStyle(bottomHeightStyle)

                const startBtnStyle = {
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)"
                }
                setstartBtnStyle(startBtnStyle)

                const startbtnText = { opacity: 1, visibility: "visible", fontSize: "1em", transition: "all 1s ease 0s" }
                setstartbtnText(startbtnText)

                const socialIconStyle = {
                    color: "#0E0E0E",
                }
                setsocialIconStyle(socialIconStyle)

                const startbtnIcon = {
                    fontSize: "150px",
                    transition: "all 1s ease 0s"
                }
                setstartbtnIcon(startbtnIcon)

                const aboutStyle = { color: "#0e0e0e" }
                setaboutStyle(aboutStyle)

                const workStyle = { color: "#0E0E0E" }
                setworkStyle(workStyle)

                setisStarted(false)
            }
        }
        else {
            if (isStarted == false) {
                const bgStyle = {
                    width: "100%",
                }
                setBgStyle(bgStyle)

                const divStyle = {
                    height: "55vh",
                    transition: "all 0.8s ease-in-out 0.9s"
                }
                setDivStyle(divStyle)

                const borderStyle = {
                    border: "2px solid rgb(252, 246, 244)",
                    borderRight: "none",
                    transition: "all 0.1s linear 0.88s"

                }
                setBorderStyle(borderStyle)

                const imgSideBorderStyle = {
                    border: "2px solid rgb(0, 0, 0)",
                    borderLeft: "none",
                    transition: "all 0.1s linear 0.88s"

                }
                setImgSideBorderStyle(imgSideBorderStyle)

                const detailsStyle = {
                    opacity: 1,
                    visibility: "visible",
                    transition: "all 0.1s ease 0.8s"
                }
                setDetailsStyle(detailsStyle)

                const imgStyle = {
                    opacity: 1,
                    visibility: "visible",
                    transform: "translateY(0)",
                    transition: "all 1s ease-in-out 1.9s"
                }
                setImgStyle(imgStyle)

                const bottomHeightStyle = {
                    height: "20%",
                    transition: "all 0.1s ease-in-out 1.4s"
                }
                setBottomHeightStyle(bottomHeightStyle)

                const startBtnStyle = {
                    top: "87.5%",
                    left: "92%",
                    transform: "translate(-50%, -50%)"
                }
                setstartBtnStyle(startBtnStyle)

                const startbtnText = { opacity: 0, visibility: "hidden", fontSize: "0em", transition: "all 1s ease 0s" }
                setstartbtnText(startbtnText)

                const socialIconStyle = {
                    color: "rgb(252, 246, 244)",
                    background: "rgb(252, 246, 244)",
                    transition: "all 0.1s ease 1.2s"
                }
                setsocialIconStyle(socialIconStyle)

                const startbtnIcon = {
                    fontSize: "120px",
                    transition: "all 1s ease 0s"
                }
                setstartbtnIcon(startbtnIcon)

                const aboutStyle = { color: "#ff792e" }
                setaboutStyle(aboutStyle)

                setisStarted(true)
            }
            if (isStarted == true) {
                const bgStyle = {
                    height: 0,
                }
                setBgStyle(bgStyle)

                const divStyle = {
                    height: 0
                }
                setDivStyle(divStyle)

                const borderStyle = {
                    border: "none"
                }
                setBorderStyle(borderStyle)

                const imgSideBorderStyle = {
                    border: "none"

                }
                setImgSideBorderStyle(imgSideBorderStyle)

                const detailsStyle = {
                    opacity: 0,
                    visibility: "hidden",
                }
                setDetailsStyle(detailsStyle)

                const imgStyle = {
                    opacity: 0,
                    visibility: "hidden",
                }
                setImgStyle(imgStyle)

                const bottomHeightStyle = {
                    height: "0%",
                }
                setBottomHeightStyle(bottomHeightStyle)

                const startBtnStyle = {
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)"
                }
                setstartBtnStyle(startBtnStyle)

                const socialIconStyle = {
                    color: "#0E0E0E",
                }
                setsocialIconStyle(socialIconStyle)

                const startbtnIcon = {
                    fontSize: "200px",
                    transition: "all 1s ease 0s"
                }
                setstartbtnIcon(startbtnIcon)

                const startbtnText = { opacity: 1, visibility: "visible", fontSize: "1em", transition: "all 1s ease 0s" }
                setstartbtnText(startbtnText)

                const aboutStyle = { color: "#0e0e0e" }
                setaboutStyle(aboutStyle)

                setisStarted(false)
            }
        }

    }

    const toAbout = (destination) => {

        if (destination == "about" || destination == "skills") {
            mainRef.current.style.transform = "translateY(-100%)";
            mainRef.current.style.opacity = "0";
            mainRef.current.style.transition = "all 0.5s ease-in-out";

            setTimeout(() => {

                if (destination == "about") {
                    navigating('/about');
                }
                else if (destination == "skills") {
                    navigating('/skills');
                }
            }, 600)
        }
        else if (destination == "work") {
            mainRef.current.style.transform = "translateX(-100%)";
            mainRef.current.style.opacity = "0";
            mainRef.current.style.transition = "all 0.5s ease-in-out";

            setTimeout(() => {
                navigating('/work');
            }, 600)
        }
        else if (destination == "contact") {
            mainRef.current.style.transform = "translateY(-100%)";
            mainRef.current.style.opacity = "0";
            mainRef.current.style.transition = "all 0.5s ease-in-out";

            setTimeout(() => {
                navigating('/contact');
            }, 600)
        }
    }

    const toHome = () => {
        navigating('/')
    }

    const [hideLoader, setHideLoader] = useState(false)

    useEffect(() => {
        // document.body.onload = () => {
        //     setHideLoader(true)
        // }
        setTimeout(() => {

            setHideLoader(true)
        }, 300)

    }, [])

    useEffect(() => {

        const t1 = gsap.timeline()

        t1
            .from(q(".stLine"), {
                height: 0,
                duration: 0.5
            }, 1.5)
            .from(q([".about", ".skills"]), {
                y: 100,
                opacity: 0,
                duration: 0.7,
                ease: "back.out(1.7)"
            })
            .from(q(".blogBtn"), {
                x: 100,
                opacity: 0,
                duration: 0.7,
                ease: "back.out(1.7)"
            }, 2)
            .from(hiRef.current, {
                y: -100,
                opacity: 0,
                duration: 0.7,
                ease: "back.out(1.7)"
            }, 2)
            .from(q(".socialIcon"), {
                scale: 0,
                opacity: 0,
                duration: 3,
                ease: "elastic",
                stagger: 0.1
            }, 2)

        return () => {
            t1.kill();
        };
    }, []);



    return (
        <>
            <div className="preloader" style={{ width: "100%", height: "100vh", background: "black", position: "fixed", top: "0", zIndex: "9999999", opacity: hideLoader && 0, visibility: hideLoader && "hidden", transition: "all 0.5s ease-in-out", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <BounceLoader color="#ff792e" size={100} />
            </div>

            <div className="mainCover" ref={mainRef} style={{ opacity: hideLoader && 1, transition: "all 0.5s ease-in-out" }}>
                <nav>
                    <div className="logo">

                        {/* {
                        isStarted ? <img src="images/s1wP.png" alt="logo" /> : <img src="images/s1bP.png" alt="logo" />
                    } */}

                        <img style={{ opacity: !isStarted && 0, visibility: !isStarted && "hidden", transition: isStarted && "all 0.1s ease 1s" }} src="images/s1wP.png" alt="logo" />
                        <img style={{ opacity: isStarted && 0, visibility: isStarted && "hidden", transition: isStarted && "all 0.1s ease 1s" }} src="images/s1bP.png" alt="logo" />
                    </div>

                    <div className="menu" onClick={toHome}>
                       <span><i className="fas fa-power-off"></i></span>
                    </div>

                    <div className="contactME" ref={hiRef}>
                        <h1 style={workStyle} onClick={() => toAbout("contact")}> Say hi.. </h1>
                    </div>
                </nav>

                <section ref={el} className="home">
                    <div className="blackBgCover">
                        <div style={bgStyle} className="blackBG"></div>
                    </div>
                    <div className="contentContainer">
                        <div style={divStyle} className="contentBox">
                            <div style={borderStyle} className="detailside">
                                <div style={detailsStyle} className="details">
                                    <h1>Hi,</h1>
                                    <h2>I'm Apardeep Singh.</h2>
                                    {/* <h3>I design and Code simple yet beautiful websites.</h3> */}
                                    <h3> I&nbsp;
                                        <Typed
                                            strings={[
                                                'design and Code simple yet beautiful websites.',
                                                'develop Wordpress websites.',
                                                'am a Chess Lover.']}
                                            typeSpeed={60}
                                            backSpeed={50}
                                            loop >
                                        </Typed>
                                    </h3>
                                </div>
                            </div>
                            <div style={imgSideBorderStyle} className="imgside">
                                <img style={imgStyle} src="images/man3.png" alt="img" />
                            </div>
                        </div>
                    </div>

                    <div className="socials">
                        <div className="socialIcon">
                            <a href="https://github.com/Apardeepsingh" target="_blank"><i style={socialIconStyle} className="fab fa-github"></i></a>
                        </div>
                        <div className="socialIcon">
                            <a href="https://www.linkedin.com/in/apardeep-singh-b8731918b/" target="_blank"><i style={socialIconStyle} className="fab fa-linkedin"></i></a>
                        </div>
                        <div className="socialIcon">
                            <a href="https://twitter.com/ApardeepSingh11" target="_blank"><i style={socialIconStyle} className="fab fa-twitter"></i></a>
                        </div>
                        <div className="socialIcon">
                            <a href="https://www.instagram.com/apardeep_singh_2000/" target="_blank"><i style={socialIconStyle} className="fab fa-instagram"></i></a>
                        </div>
                        <span className="stLine" style={socialIconStyle}></span>
                    </div>

                    <div style={workStyle} className=" blogBtn" onClick={() => toAbout("work")}>
                        <h2>Work</h2>
                    </div>

                    {/* <div className="workBtn" style={{ color: isStarted && "#ff792e" }}>
                        <h2>Blog</h2>
                    </div> */}

                    <div style={bottomHeightStyle} className="bottomNavbtns">
                        <span style={aboutStyle} className="about" onClick={() => toAbout("about")}>
                            <h2>About.</h2>
                        </span>
                        <span className="skills" onClick={() => toAbout("skills")}>
                            <h2>My Skills.</h2>
                        </span>
                    </div>

                    <div style={startBtnStyle} className="startBtn" onClick={startWebsite}>
                        <i style={startbtnIcon} className="fas fa-yin-yang"></i>
                        <span style={startbtnText}>Click here</span>
                    </div>

                </section>
            </div>
        </>
    )
}

export default Home;